// 위기 로컬 1차 필터 + 지역별 리소스 (안전 핵심 — 평문, 시적 위로 금지).
//   - 자기 지향 표현만 잡는다. 타인 지향 분노("죽이고 싶다")는 NOT crisis.
//   - 자해 *방법* 단어는 넣지 않는다 — 의도·고통 표현 중심.
//   - 1차 트리거일 뿐. AI Pass A가 맥락(과장 vs 진짜)을 확정한다.
//   - ⚠️ 출시 전 안전·임상 검수 + 시장별 현지화 + 번호·운영시간 재검증 필수.

import type { Lang } from "./types";

const KR_PATTERNS: RegExp[] = [
  /죽고\s*싶/, /사라지고\s*싶/, /없어지고\s*싶/, /살기\s*싫/, /살고\s*싶지\s*않/,
  /더는?\s*못\s*살/, /자해/, /자살/, /내가\s*없어지면/,
];
const EN_PATTERNS: RegExp[] = [
  /\bwant to die\b/i, /\bwanna die\b/i, /\bkill myself\b/i, /\bkms\b/i, /\bend my life\b/i,
  /\bdon'?t want to live\b/i, /\bcan'?t go on\b/i, /\bsuicidal\b/i, /\bhurt myself\b/i, /\bno reason to live\b/i,
];
const JA_PATTERNS: RegExp[] = [
  /死にたい/, /消えたい/, /いなくなりたい/, /生きていたくない/, /生きるのがつら/,
  /もう生きられない/, /自殺/, /自傷/, /リスカ/,
];

/** 로컬 1차 트리거 여부. true면 곧장 안전면(원문을 AI로 보내지 않음). */
export function localCrisisTrigger(text: string): boolean {
  const t = text.normalize("NFC");
  return KR_PATTERNS.some((re) => re.test(t)) || EN_PATTERNS.some((re) => re.test(t)) || JA_PATTERNS.some((re) => re.test(t));
}

// 위기 안전면(S6)의 리소스 행. 1순위(primary)를 가장 또렷하게.
export interface Resource {
  label: string;
  value: string;
  note?: string;
  primary?: boolean;
  href?: string; // 명시 링크(전화/URL 자동 판별 대신 강제). 예: 카카오 채널 채팅.
}

export const RESOURCES: Record<Lang, Resource[]> = {
  ko: [
    { label: "자살예방 상담전화", value: "109", note: "24시간 · 통화료 무료", primary: true },
    { label: "정신건강 상담전화", value: "1577-0199" },
    { label: "청소년 상담전화", value: "1388", note: "청소년 전용" },
    { label: "카카오톡 채널 ‘마들랜’", value: "채팅", href: "https://pf.kakao.com/_DAxbYG" },
  ],
  en: [
    { label: "988 Suicide & Crisis Lifeline", value: "988", note: "call or text · 24/7", primary: true },
    { label: "Crisis Text Line", value: "text HOME to 741741" },
    { label: "The Trevor Project (LGBTQ youth)", value: "1-866-488-7386" },
    { label: "Chat online", value: "988lifeline.org" },
  ],
  ja: [
    { label: "よりそいホットライン", value: "0120-279-338", note: "24時間 · 通話無料", primary: true },
    { label: "こころの健康相談統一ダイヤル", value: "0570-064-556" },
    { label: "いのちの電話", value: "0570-783-556", note: "ナビダイヤル 10:00〜22:00" },
  ],
};

export function resourcesFor(lang: Lang): Resource[] {
  return RESOURCES[lang] ?? RESOURCES.en;
}
